import BigNumber from 'bignumber.js';

import { api, cacheTags, IConnectedActionParams } from 'modules/api';
import { getMainTokenBalance } from 'modules/api/methods/getMainTokenBalance';
import { asAddress } from 'modules/api/utils/asAddress';
import { getWalletClient } from 'modules/api/walletClient';

export const { useGetMainTokenBalanceQuery } = api.injectEndpoints({
  endpoints: build => ({
    getMainTokenBalance: build.query<BigNumber, IConnectedActionParams>({
      queryFn: async () => {
        const walletClient = getWalletClient();

        const result = await getMainTokenBalance(
          asAddress(walletClient?.account?.address),
        );

        return { data: result };
      },
      providesTags: [cacheTags.account],
    }),
  }),
});
